import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_CLIENTS, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_CLIENT,
  UPDATE_CLIENT,
  DELETE_CLIENT,
  ADD_PARTNER
 } from "./actionTypes";
import {
  getClientsSuccess,
  getClientsFail,
  addClientSuccess,
  addClientFail,
  updateClientSuccess,
  updateClientFail,
  deleteClientSuccess,
  deleteClientFail,
  addPartnerSuccess,
  addPartnerFail,
  // getClientProfileSuccess,
  // getClientProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getClients,
  // getClientProfile,
  addNewClient,
  updateClient,
  deleteClient,
  addNewPartner,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchClients({payload}) {
  try {
    const response = yield call(getClients,payload);
    yield put(getClientsSuccess(response));
  } catch (error) {
    yield put(getClientsFail(error));
  }
}

function* onUpdateClient({ payload: { client, history } }) {
  try {
   let response = yield call(updateClient, client);
  //  if(response.file_src || client.removeImage) client.image = response.file_src
    yield put(updateClientSuccess(client));
    history && history.push("/clients")
  } catch (error) {
    yield put(updateClientFail(error));
    yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onDeleteClient({ payload: client }) {
  try {
     yield call(deleteClient, client);
    yield put(deleteClientSuccess(client));
  } catch (error) {
    yield put(deleteClientFail(error));
  }
}

function* onAddNewClient({ payload: { client,history }}) {
  try {

    let response = yield call(addNewClient, client)
    yield put(addClientSuccess(response.data))
    history.push("/clients")
  } catch (error) {
    yield put(addClientFail(error))
    yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onAddNewPartner({ payload }) {
  try {
    let response = yield call(addNewPartner, payload)
    yield put(addPartnerSuccess(response.data))
    window.open('https://pyne-mena.com')
  } catch (error) {
    yield put(showPopup({title:error.response.data.message,error:true}));
    yield put(addPartnerFail(error))
  }
}


// function* fetchClientProfile() {
//   try {
//     const response = yield call(getClientProfile);
//     yield put(getClientProfileSuccess(response));
//   } catch (error) {
//     yield put(getClientProfileFail(error));
//   }
// }

function* clientsSaga() {
  yield takeEvery(GET_CLIENTS, fetchClients);
  yield takeEvery(ADD_NEW_CLIENT, onAddNewClient);
  yield takeEvery(ADD_PARTNER, onAddNewPartner);
  yield takeEvery(UPDATE_CLIENT, onUpdateClient);
  yield takeEvery(DELETE_CLIENT, onDeleteClient);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchClientProfile);
}

export default clientsSaga;
